import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=1637af81&scoped=true&"
import script from "./NoResult.vue?vue&type=script&lang=js&"
export * from "./NoResult.vue?vue&type=script&lang=js&"
import style0 from "./NoResult.vue?vue&type=style&index=0&id=1637af81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637af81",
  null
  
)

export default component.exports